module.exports = __webpack_public_path__ + "static/media/banner-cloud-platinum-zadarmo.c525f569.jpg";